import { DataTableColumnHeader } from "@/components/ui";
import { type ReportsMatterStatusCount } from "@/lib/types";
import { type ColumnDef } from "@tanstack/react-table";
import startCase from "lodash/startCase";

export const getMatterStatusCountReportColumns = (
  selectedCategories?: string[],
): ColumnDef<ReportsMatterStatusCount>[] =>
  [
    {
      accessorFn: (row) => {
        if (row.category) {
          return startCase(row.category);
        }
        if (!selectedCategories || selectedCategories.length === 0) {
          return "-";
        }
        if (selectedCategories.length === 1) {
          return startCase(selectedCategories[0]);
        }
        return "Multiple";
      },
      id: "Category",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ getValue }) => getValue<string>(),
      enableHiding: false,
    },
    {
      accessorKey: "label",
      id: "Status",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => row.original.label,
      enableHiding: false,
    },
    {
      accessorKey: "count",
      id: "Number of Matters",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => row.original.count.toLocaleString(),
      enableSorting: true,
    },
  ] as ColumnDef<ReportsMatterStatusCount>[];
